import { useMutation, useQueryClient } from '@tanstack/react-query'

import { communityApi } from '../api/communityApi'
import type { COMMUNITY_LIFETIME } from '../models/community.constants'
import { invalidateSubscriptionQueries } from '../utils/invalidateSubscriptionQueries'
import { communityQueryOptions } from './useCommunityQuery'

export const useLeaveCommunityMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ id }: { id: number; lifetime: COMMUNITY_LIFETIME | undefined }) => communityApi.leaveCommunity(id),
    onSuccess: (_, { id, lifetime }) => {
      queryClient.setQueryData(communityQueryOptions(id).queryKey, (data) => {
        if (!data) return data
        return { ...data, hasJoined: false }
      })
      invalidateSubscriptionQueries(queryClient, { id, lifetime, hasJoined: true })
    },
  })
}
